module.exports = __webpack_public_path__ + "img/default.af37ee9a.svg";